export default "/assets/website/images/violin.svg?5661d70fdc89ae80cc0d065b89ef017b";